export const listOfAreas = {
"FOND CAPECHE, VIEUX-FORT" :  null,
"ROSEAU VALLEY, ANSE LA RAYE" :  null,
"BARON'S DRIVE/COIN DE L'ANSE, SOUFRIERE" :  null,
"MORNE VIENT, MICOUD" :  null,
"MALGRETOUTE, MICOUD" :  null,
"CONWAY, CASTRIES" :  null,
"VENUS, ANSE LA RAYE" :  null,
"DURANDEAU, ANSE LA RAYE" :  null,
"CACAO/VIGIE,  MICOUD" :  null,
"BRUCEVILLE/SHANTY TOWN, VIEUX-FORT" :  null,
"CHIQUE/BLANCHARD, MICOUD" :  null,
"ANSE LA VERDUE, CANARIES" :  null,
"VILLAGE, ANSE LA RAYE" :  null,
"LEZY, MICOUD" :  null,
"SAND DE FEU, CASTRIES" :  null,
"BELMONT, DENNERY" :  null,
"MILLET, ANSE LA RAYE" :  null,
"PARC ESTATE, LABORIE" :  null,
"LA PELLE, DENNERY" :  null,
"TROU COCHON/MARC, CASTRIES" :  null,
"COOLIE TOWN, CASTRIES" :  null,
"ST LAWRENCE, ANSE LA RAYE" :  null,
"ANSE LA RAYE" :  null,
"PALMISTE, SOUFRIERE" :  null,
"COOLIE TOWN, VIEUX-FORT" :  null,
"CHRISTIAN HILL, CHOISEUL" :  null,
"VOLET, MICOUD" :  null,
"LA POINTE, DENNERY" :  null,
"WESTALL GROUP/THE MANGUE, VIEUX-FORT" :  null,
"DUBRASSAY, CASTRIES" :  null,
"JEAN BAPTISTE, ANSE LA RAYE" :  null,
"FOND BERANGE, LABORIE" :  null,
"BOIS D'INDE, CHOISEUL" :  null,
"ST LAWRENCE ESTATE, ANSE LA RAYE" :  null,
"NEWFIELD/FIETTE, CHOISEUL" :  null,
"SULPHUR SPRINGS, SOUFRIERE" :  null,
"FRANCIOU, CHOISEUL" :  null,
"TETE CHEMIN/MILLET, ANSE LA RAYE" :  null,
"DENNERY BY PASS/ROCKY LANE, DENNERY" :  null,
"CHASSIN/BABONNEAU, CASTRIES" :  null,
"CAFFIERE, CHOISEUL" :  null,
"CARIERRE, VIEUX-FORT" :  null,
"VILLAGE, CANARIES" :  null,
"BALCA, LABORIE" :  null,
"ESPERANCE, CHOISEUL" :  null,
"MORNE D'OR, ANSE LA RAYE" :  null,
"MACDOMEL, LABORIE" :  null,
"MORNE PANACHE, DENNERY" :  null,
"LAMAZE, CHOISEUL" :  null,
"GOMIER, MICOUD" :  null,
"MONZIE, CHOISEUL" :  null,
"GADETTE, DENNERY" :  null,
"DERRIERE MORNE, CHOISEUL" :  null,
"LA PERLE, LABORIE" :  null,
"BELAIR, CASTRIES" :  null,
"BOUTON, SOUFRIERE" :  null,
"SAROT, CASTRIES" :  null,
"DERNIERE RIVIERE, DENNERY" :  null,
"AU LEON, DENNERY" :  null,
"BELVEDERE, CANARIES" :  null,
"CROWNLANDS/MARC, CASTRIES" :  null,
"FAUX A CHAUD, CASTRIES" :  null,
"BOIS D'INDE, ANSE LA RAYE" :  null,
"MOCHA, SOUFRIERE" :  null,
"BELVEDERE, SOUFRIERE" :  null,
"MORNE LA CROIX, SOUFRIERE" :  null,
"LUMIERE, DENNERY" :  null,
"BLANCHARD, MICOUD" :  null,
"CHAMPEN ESTATE, ANSE LA RAYE" :  null,
"DUGARD, MICOUD" :  null,
"CANARIES" :  null,
"LA POINTE, CHOISEUL" :  null,
"LENNY HILL, SOUFRIERE" :  null,
"GRACE, VIEUX-FORT" :  null,
"TROIS PITON, CASTRIES" :  null,
"RAVENEAU, CHOISEUL" :  null,
"CAICO/MILLET, ANSE LA RAYE" :  null,
"DUBONAIRE, DENNERY" :  null,
"DELCER, CHOISEUL" :  null,
"LA COURVILLE, MICOUD" :  null,
"LONDON ROAD, MICOUD" :  null,
"MORNE CISEAUX, ANSE LA RAYE" :  null,
"LA CAYE, DENNERY" :  null,
"LA HAUT, LABORIE" :  null,
"FOND MANGER, CASTRIES" :  null,
"BARRE DUCHAUSSEE, CASTRIES" :  null,
"MONKEY TOWN/CICERON, CASTRIES" :  null,
"CUL DE SAC, CASTRIES" :  null,
"GAYABOIS, LABORIE" :  null,
"TETE MORNE, LABORIE" :  null,
"ZENON, SOUFRIERE" :  null,
"LA POINTE, MICOUD" :  null,
"DENNERY BY PASS/GREEN MOUNTAIN, DENNERY" :  null,
"BARRE ST JOSEPH, CASTRIES" :  null,
"BOIS D'INDE, SOUFRIERE" :  null,
"ROBLOT, CHOISEUL" :  null,
"CHATEAU BELAIR, SOUFRIERE" :  null,
"PRASLIN, MICOUD" :  null,
"VILLAGE, CHOISEUL" :  null,
"KENNEDY HIGHWAY, LABORIE" :  null,
"PONYON, CHOISEUL" :  null,
"CANTONEMENT, VIEUX-FORT" :  null,
"MORNE VERT, VIEUX-FORT" :  null,
"LA RETRAITE, VIEUX-FORT" :  null,
"DABAN, LABORIE" :  null,
"ST PHILLIP, SOUFRIERE" :  null,
"DERIERRE MORNE, VIEUX-FORT" :  null,
"MARCHAND, CASTRIES" :  null,
"MORNE SION, CHOISEUL" :  null,
"THAMAZO, DENNERY" :  null,
"GRANDE RAVINE, DENNERY" :  null,
"SALTIBUS, LABORIE" :  null,
"PEROU, CASTRIES" :  null,
"LABAYEE, CASTRIES" :  null,
"INDUSTRY, CHOISEUL" :  null,
"OLIBO, LABORIE" :  null,
"GRANDE RIVIERE, DENNERY" :  null,
"BARA BARA, DENNERY" :  null,
"MORNE CAYENNE, VIEUX-FORT" :  null,
"ESPERANCE,  VIEUX-FORT" :  null,
"CHOPPIN, CASTRIES" :  null,
"JACMEL, ANSE LA RAYE" :  null,
"MORNE JACQUES, CHOISEUL" :  null,
"DEGLOS, CASTRIES" :  null,
"DES BLANCHARD, MICOUD" :  null,
"RAVINE POISSON, CASTRIES" :  null,
"ESPERANCE, SOUFRIERE" :  null,
"RAVINE CLAIRE, SOUFRIERE" :  null,
"DES BARRAS, GROS ISLET" :  null,
"BANSE, LABORIE" :  null,
"LA CROIX MAINGOT, CASTRIES" :  null,
"GETRINE, LABORIE" :  null,
"BOGUIS, GROS ISLET" :  null,
"BARRE DENIS, CASTRIES" :  null,
"LOMBARD, MICOUD" :  null,
"MONCHY/LA BORNE, GROS ISLET" :  null,
"FOND ASSAU/BABONNEAU, CASTRIES" :  null,
"DOCAMEL/LA RESOURCE, VIEUX-FORT" :  null,
"DERNIERE RIVIERE/MARDI GRAS/MORNE CACA COCHON, DENNERY" :  null,
"DENNERY VILLAGE, DENNERY" :  null,
"WILTON'S YARD/GRAVE YARD, CASTRIES" :  null,
"FOND/DESRUISSEAUX, MICOUD" :  null,
"DENNERY" :  null,
"DUGARD, CHOISEUL" :  null,
"VIEUX FORT/LABORIE HIGHWAY, VIEUX-FORT" :  null,
"GEORGE CHARLES BOULEVARD, CASTRIES" :  null,
"MONGOUGE, CHOISEUL" :  null,
"TROU ROUGE, CASTRIES" :  null,
"MONCHY/RAVINE MACOCK, GROS ISLET" :  null,
"VANARD, ANSE LA RAYE" :  null,
"RIVERSIDE ROAD, CANARIES" :  null,
"MICOUD" :  null,
"MARC, CASTRIES" :  null,
"ODSAN, CASTRIES" :  null,
"GRANDE RIVIERE/ASSOU CANAL, GROS ISLET" :  null,
"GARRAND, GROS ISLET" :  null,
"DESRAMEAUX, GROS ISLET" :  null,
"BAGATELLE, CASTRIES" :  null,
"SAVANNES GEORGE/CONSTITUTION PARK, CHOISEUL" :  null,
"DIAMOND/DIAMOND ESTATE, SOUFRIERE" :  null,
"TI ROCHER, MICOUD" :  null,
"CATIN, VIEUX-FORT" :  null,
"LONDONDERRY, LABORIE" :  null,
"VILLAGE, MICOUD" :  null,
"THOMAZO/TOURNESSE, DENNERY" :  null,
"CHOISEUL" :  null,
"PATTERSON'S GAP, CASTRIES" :  null,
"NEW VILLAGE, CASTRIES" :  null,
"BELFOND, SOUFRIERE" :  null,
"RAVINE TOUTERELLE, CASTRIES" :  null,
"LA RESSOURCE, DENNERY" :  null,
"BOIS PATAT, CASTRIES" :  null,
"NEW VILLAGE, MICOUD" :  null,
"GUESNEAU, CASTRIES" :  null,
"ANSE GER, MICOUD" :  null,
"VIEUX-FORT" :  null,
"VICTORIA, CHOISEUL" :  null,
"AGARD LANDS, CASTRIES" :  null,
"RICHE FOND/LA BELLE VIE, DENNERY" :  null,
"LESLIE LAND, CASTRIES" :  null,
"RICHE FOND/NEW VILLAGE, DENNERY" :  null,
"QUATRE CHEMINS, CASTRIES" :  null,
"GRASS STREET, CASTRIES" :  null,
"AURENDEL HILL, CASTRIES" :  null,
"TOWN, SOUFRIERE" :  null,
"EAU PIQUANT/ST URBAIN, VIEUX-FORT" :  null,
"GIRARD/BABONNEAU, CASTRIES" :  null,
"PAIX BOUCHE, MICOUD" :  null,
"DACRETIN, CHOISEUL" :  null,
"BEXON, CASTRIES" :  null,
"GENTIL, LABORIE" :  null,
"LASTIC HILL, CASTRIES" :  null,
"CABICHE/BABONNEAU, CASTRIES" :  null,
"CAPITAL HILL, CASTRIES" :  null,
"ANSE CANOT, DENNERY" :  null,
"MORNE ASSAU/BABONNEAU, CASTRIES" :  null,
"ROCK HALL, CASTRIES" :  null,
"TI COLON, CASTRIES" :  null,
"PIERROT, VIEUX-FORT" :  null,
"FOND GENS LIBRE, SOUFRIERE" :  null,
"TOWN, VIEUX-FORT" :  null,
"LA GUERRE, GROS ISLET" :  null,
"MORNE DUDON, CASTRIES" :  null,
"GROS ISLET TOWN, GROS ISLET" :  null,
"MONCHY, GROS ISLET" :  null,
"MAYNARD HILL, CASTRIES" :  null,
"DERIERRE FORT/OLD VICTORIA ROAD, CASTRIES" :  null,
"MORNE CITON, GROS ISLET" :  null,
"HOSPITAL ROAD, CASTRIES" :  null,
"BANSE LA GRACE, LABORIE" :  null,
"MARIGOT, CASTRIES" :  null,
"TI ROCHER, CASTRIES" :  null,
"DENNERY BY PASS, DENNERY" :  null,
"GEORGEVILLE, CASTRIES" :  null,
"DEBREIUL, CHOISEUL" :  null,
"BISSEE, CASTRIES" :  null,
"RICHE FOND, DENNERY" :  null,
"PATIENCE, MICOUD" :  null,
"TALVERN/BABONNEAU, CASTRIES" :  null,
"BOGUIS/DESA BLOND, GROS ISLET" :  null,
"PAVEE, CASTRIES" :  null,
"ROSE HILL, CASTRIES" :  null,
"GIRAUD, LABORIE" :  null,
"CASTRIES" :  null,
"FOND BERNIER, SOUFRIERE" :  null,
"LABORIE" :  null,
"DESRUISSEAUX, MICOUD" :  null,
"PAIX BOUCHE, GROS ISLET" :  null,
"L'EAU MINEAU, MICOUD" :  null,
"DESPINOZE, DENNERY" :  null,
"BELLE VUE, CHOISEUL" :  null,
"MONCHY/TI DAUPHIN, GROS ISLET" :  null,
"WATERWORKS, CASTRIES" :  null,
"FORESTIERE, CASTRIES" :  null,
"SUNBILT, CASTRIES" :  null,
"AU TABOR HILL, ANSE LA RAYE" :  null,
"MONCHY/VIEUX SUCREIC, GROS ISLET" :  null,
"BLACK MALLET, CASTRIES" :  null,
"BOIS CATCHET, CASTRIES" :  null,
"MONCHY/MALGRETOUTE, GROS ISLET" :  null,
"ACTIVE HILL, CASTRIES" :  null,
"LE RICHE, CHOISEUL" :  null,
"LA TOC, CASTRIES" :  null,
"ETANGS, SOUFRIERE" :  null,
"CICERON, CASTRIES" :  null,
"FOND CANIE, CASTRIES" :  null,
"LA HAUT, MICOUD" :  null,
"DELAIDE, DENNERY" :  null,
"VILLAGE, LABORIE" :  null,
"GREEN GOLD/BABONNEAU, CASTRIES" :  null,
"LA RESOURCE, VIEUX-FORT" :  null,
"MON REPOS, MICOUD" :  null,
"RESINARD, CASTRIES" :  null,
"LA CROIX CHAUBOUGH, GROS ISLET" :  null,
"BABONNEAU PROPER, CASTRIES" :  null,
"CEDARS, CASTRIES" :  null,
"MONCHY/RIVIERE MITAN, GROS ISLET" :  null,
"POMME, VIEUX-FORT" :  null,
"RAVINE CHABOT, CASTRIES" :  null,
"AUGIER, VIEUX-FORT" :  null,
"CITY, CASTRIES" :  null,
"PIAYE, LABORIE" :  null,
"BOCAGE, CASTRIES" :  null,
"CACOA/BABONNEAU, CASTRIES" :  null,
"GOODLANDS, CASTRIES" :  null,
"GRANDE RIVIERE/DEGAZON, GROS ISLET" :  null,
"LA CARIERRE, CASTRIES" :  null,
"BALATA, CASTRIES" :  null,
"BELLA ROSA, CASTRIES" :  null,
"LA FARGUE, CHOISEUL" :  null,
"BISHOP'S GAP/GHIRAWOO ROAD, CASTRIES" :  null,
"LA PANSEE, CASTRIES" :  null,
"BANANNES BAY, CASTRIES" :  null,
"L'HERMITAGE, GROS ISLET" :  null,
"MONCHY/LAFEUILLE, GROS ISLET" :  null,
"HILL 20/BABONNEAU, CASTRIES" :  null,
"PLATEAU, GROS ISLET" :  null,
"BARNARD HILL, CASTRIES" :  null,
"BELLE PLAIN, SOUFRIERE" :  null,
"NEW DEVELOPMENT, SOUFRIERE" :  null,
"UNION/TI MORNE, GROS ISLET" :  null,
"DARLING ROAD, CASTRIES" :  null,
"MALGRETOUTE, SOUFRIERE" :  null,
"CITY GATE, CASTRIES" :  null,
"SAUZAY, CHOISEUL" :  null,
"GRANDE RIVIERE/MORNE SERPENT, GROS ISLET" :  null,
"VIDE BOUTEILLE, CASTRIES" :  null,
"LA CLERY, CASTRIES" :  null,
"GRANDE RIVIERE/NORBERT, GROS ISLET" :  null,
"REUNION, CHOISEUL" :  null,
"PEARTS GAP, CASTRIES" :  null,
"BEAUSEJOUR/MYERS BRIDGE, SOUFRIERE" :  null,
"LA TOURNEY/CEDAR HEIGHTS, VIEUX-FORT" :  null,
"BOIS D'ORANGE, GROS ISLET" :  null,
"RIVER DOREE, CHOISEUL" :  null,
"MORNE ROAD, CASTRIES" :  null,
"DERIERRE BOIS, VIEUX-FORT" :  null,
"LANSE ROAD, CASTRIES" :  null,
"GRANDE RIVIERE/PIAT, GROS ISLET" :  null,
"MONGIRAUD, GROS ISLET" :  null,
"SAVANNES, MICOUD" :  null,
"CRESSLANDS, SOUFRIERE" :  null,
"BEAUCHAMP, MICOUD" :  null,
"MASSADE, GROS ISLET" :  null,
"INDEPENDENCE CITY, CASTRIES" :  null,
"GRANDE RIVIERE, GROS ISLET" :  null,
"ST JUDE'S HIGHWAY, VIEUX-FORT" :  null,
"BLACK BAY, VIEUX-FORT" :  null,
"AU TABOR, ANSE LA RAYE" :  null,
"CAYE MANJE', GROS ISLET" :  null,
"MONCHY/LA RETRAITE, GROS ISLET" :  null,
"CHASE GARDENS, CASTRIES" :  null,
"MONCHY/CAREFFE, GROS ISLET" :  null,
"YORKE HILL, CASTRIES" :  null,
"BOIS D'ORANGE/TROUYA, GROS ISLET" :  null,
"H'ERELLE, LABORIE" :  null,
"BOIS JOLI, DENNERY" :  null,
"GROS ISLET" :  null,
"MONCHY/MOULIN A VENT, GROS ISLET" :  null,
"TI RIVIERE, MICOUD" :  null,
"MONIER, GROS ISLET" :  null,
"REDUIT, GROS ISLET" :  null,
"UNION, GROS ISLET" :  null,
"CAS EN BAS, GROS ISLET" :  null,
"MARISULE, GROS ISLET" :  null,
"SAPHIRE, LABORIE" :  null,
"BEAUSEJOUR, GROS ISLET" :  null,
"MOULE A CHIQUE, VIEUX-FORT" :  null,
"SAN SOUCI, CASTRIES" :  null,
"BELLA ROSA, GROS ISLET" :  null,
"GRANDE RIVIERE/INGLE WOODS, GROS ISLET" :  null,
"THE MORNE, CASTRIES" :  null,
"CORINTH, GROS ISLET" :  null,
"MARISULE/EAST WINDS, GROS ISLET" :  null,
"REDUIT PARK, GROS ISLET" :  null,
"ENTREPOT, CASTRIES" :  null,
"GRANDE RIVIERE/WHITE ROCK, GROS ISLET" :  null,
"BELLE VUE, GROS ISLET" :  null,
"INDUSTRIAL ESTATE, VIEUX-FORT" :  null,
"FOND CACOA, SOUFRIERE" :  null,
"MARISULE/BON AIR, GROS ISLET" :  null,
"UNION TERRACE, GROS ISLET" :  null,
"BALEMBOUCHE, LABORIE" :  null,
"ALMONDALE, CASTRIES" :  null,
"HILLCREST GARDENS, CASTRIES" :  null,
"BONNETERRE GARDENS, GROS ISLET" :  null,
"CORINTH ESTATE, GROS ISLET" :  null,
"CARELLIE, CASTRIES" :  null,
"TAPION, CASTRIES" :  null,
"DENNERY BY PASS/WHITE ROCK GARDENS, DENNERY" :  null,
"SUMMERSDALE, CASTRIES" :  null,
"BEANE FIELD, VIEUX-FORT" :  null,
"ESCAP, MICOUD" :  null,
"HEWANORRA ORCHARD, VIEUX-FORT" :  null,
"REDUIT ORCHARD, GROS ISLET" :  null,
"RODNEY BAY, GROS ISLET" :  null,
"BEAUSEJOUR, VIEUX-FORT" :  null,
"MASSACRE, ANSE LA RAYE" :  null,
"SUNNY ACRES, CASTRIES" :  null,
"MARISULE/TOP OF THE WORLD, GROS ISLET" :  null,
"BONNETERRE, GROS ISLET" :  null,
"VIGIE, CASTRIES" :  null,
"COUBARIL, CASTRIES" :  null,
"CAP ESTATE/BECUNE PARK, GROS ISLET" :  null,
"RODNEY HEIGHTS, GROS ISLET" :  null,
"CAP ESTATE/GOLF PARK, GROS ISLET" :  null,
"CAP ESTATE, GROS ISLET" :  null,
}